const Loader = () => {
  return (
    <div className="absolute top-0 left-0 z-10 flex h-full w-full items-center justify-center rounded-lg bg-slate-100/50 dark:bg-slate-800/50">
      <div className="h-24 w-24 animate-spin rounded-full border-4 border-t-4 border-t-blue-500" />
    </div>
  );
};

export default Loader;
